export default __webpack_public_path__ + "static/media/25120408.2a02d18c.png";